import ExternalUtil from '../ExternalUtil';

/** Return true if e2e testing is enabled via local storage */
export const isE2eBot = (): boolean => {
  try {
    if (typeof window === 'undefined' || typeof window.localStorage !== 'object') {
      return false;
    }
    return !!window.localStorage.e2eBot;
  } catch {
    return false;
  }
};

export const isSignupTestEnabled = (): boolean => {
  try {
    if (typeof window === 'undefined' || typeof window.localStorage !== 'object') {
      return false;
    }
    if (ExternalUtil.isProduction()) {
      console.log('In production environment, skipping signup test');
      return false;
    }

    return !!window.localStorage.e2eSignupTest;
  } catch {
    return false;
  }
};
